export default "__VITE_ASSET__BJjR3gGU__"